export default {
  ConfigStepBeforeUsing: 'Các bước thiết lập cần thiết cho đơn vị trước khi sử dụng',
  ManualMenuDesc: 'Thiết lập các bước dưới đây để bắt đầu sử dụng phần mềm',
  AddDepartment: {
    Title: 'Thêm danh sách phòng ban',
    Desc: 'Thiết lập danh sách các phòng ban của đơn vị',
    BtnNavigate: 'Đi tới thiết lập phòng ban',
  },
  AddUser: {
    Title: 'Thêm danh sách người dùng',
    Desc: 'Thiết lập danh sách người dùng của đơn vị',
    BtnNavigate: 'Đi tới thiết lập người dùng',
    Step1: 'Nhập các trường thông tin về người dùng',
    Step2: `<div>Chọn vị trí tương ứng với từng vai trò người dùng (để đọc chi tiết về vai trò, trỏ chuột vào <div style="vertical-align: top; display: inline-block;" class="icon-info icon16 ic-info-gray"></div>)</div>`
  },
  ConfigUserRole: {
    Title: 'Phân quyền vai trò người dùng',
    Desc: 'Thiết lập vai trò của người dùng trong đơn vị',
    BtnNavigate: 'Đi tới thiết lập vai trò',
  },
  ConfigGeneralSetting: {
    Title: 'Thiết lập chung',
    Desc: 'Thiết lập chức vụ, mức độ ưu tiên, loại việc, đánh giá công việc và thời gian được phép quá hạn',
    BtnNavigate: 'Đi tới thiết lập chung',
  },
  UserList: {
    Step1: 'Thực hiện thêm mới người dùng của đơn vị',
    Step2: 'Sử dụng chức năng nhập khẩu để tải tệp chứa thông tin người dùng của đơn vị',
    Step3: 'Sử dụng chức năng lấy từ hồ sơ MISA QLCB để đồng bộ hồ sơ CBCCVC thành người dùng của Taskgo'
  },
  Step1ImportUser: {
    Step1: 'Tải xuống tệp mẫu để biết các trường thông tin khi nhập khẩu danh sách người dùng',
    Step2: 'Tải lên tệp để nhập khẩu danh sách người dùng',
    Step3: 'Chọn Sheet nhập khẩu và Dòng tiêu đề tương ứng với file đã đăng tải'
  },
  Step2ImportUser: {
    Step1: 'Thực hiện đồng nhất các trường thông tin của phần mềm với các trường thông tin trên tệp nhập khẩu',
    Step2: 'Trong trường hợp đăng tải sai tệp, có thể dùng chức năng quay lại để tải tệp khác'
  },
  Step3ImportUser: {
    Step1: 'Kết quả nhập khẩu sẽ được hiển thị tại đây',
    Step2: 'Tải xuống những bản ghi không hợp lệ để chỉnh sửa',
    Step3: 'Thực hiện nhập khẩu danh sách người dùng của đơn vị lên trên phần mềm'
  },
  LiveChat: {
    Mess: "Chọn vào biểu tượng tin nhắn để liên hệ với chúng tôi nếu cần hỗ trợ."
  },
}